module.exports = __webpack_public_path__ + "12897c0b2f3b13a6b23426df1390748b.svg";